import { z } from "zod"
import { BackofficeBlockedConversationReasonEnum } from "./dtos"

export const BackofficeWhatsappRouteResponseDataSchema = z.object({
  senderCallingCode: z.string(),
  recipientCallingCode: z.string(),
  deliveredCount: z.number(),
  blockedCount: z.number(),
  evidence: z.number(),
  blockedProbability: z.number(),
  hasEnoughEvidence: z.boolean(),
  isBlocked: z.boolean(),
  numbersCount: z.number(),
  lastDeliveredAt: z
    .date()
    .transform((value) => value.toISOString())
    .nullable(),
  lastBlockedAt: z
    .date()
    .transform((value) => value.toISOString())
    .nullable(),
})

const OutcomeCountsSchema = z.object({
  delivered: z.number(),
  blocked: z.number(),
  pending: z.number(),
})

export const BackofficeWhatsappRoutesResponseDataSchema = z.object({
  routes: z.array(BackofficeWhatsappRouteResponseDataSchema),
  decisions: z.object({
    total: z.number(),
    sends: OutcomeCountsSchema,
    probes: OutcomeCountsSchema,
    skipped: z.number(),
    rerouted: OutcomeCountsSchema,
  }),
  decisionsSince: z.date().transform((value) => value.toISOString()),
})

export const BackofficeBlockedConversationResponseDataSchema = z.object({
  conversationId: z.bigint().transform(String),
  createdAt: z.date().transform((value) => value.toISOString()),
  companyName: z.string(),
  senderNumber: z.string().nullable(),
  recipientCallingCode: z.string(),
  reason: z.enum(BackofficeBlockedConversationReasonEnum),
  isRerouted: z.boolean(),
})

export const BackofficeBlockedConversationsResponseDataSchema = z.array(
  BackofficeBlockedConversationResponseDataSchema,
)
